<template>
  <IconList1 :name="name" :color="color" :size="size" />
</template>

<script>
import IconList1 from "./iconList1";
export default {
  name: "icons.vue",
  components: {
    IconList1,
  },
  props: {
    name: {
      required: true,
    },
    color: {
      required: false,
      default: 'currentColor'
    },
    size: {
      required: false,
      default: '30'
    }
  },
}
</script>





